import { zodResolver } from "@hookform/resolvers/zod";
import { UserAccountType } from "@spz/shared-domain";
import type { TFunction } from "i18next";
import * as z from "zod";

export const inviteUserFormSchema = (t: TFunction) => {
  return z.object({
    email: z.email({
      message: t("email_invalid"),
    }),
    firstName: z.string().min(2, {
      message: t("firstname_min_length"),
    }),
    lastName: z.string().min(2, {
      message: t("lastname_min_length"),
    }),
    accountType: z.enum(UserAccountType),
  });
};

export type InviteUserFormValues = z.infer<
  ReturnType<typeof inviteUserFormSchema>
>;

export const inviteUserResolver = (t: TFunction) =>
  zodResolver(inviteUserFormSchema(t));
